import request from '../utils/request'

//获取验证码图片
export function getVerify() {
  return request.get('/captcha/getVerify')
}

//检查验证码正确性
export function checkCaptcha(captchaKey,captchaCode) {
    return request.get(`/captcha/checkCaptcha/${captchaKey}/${captchaCode}`)
}